<template>
    <div class="pu_AdminLayout">
        <div class="pu_AdminWrap">

            <inc_zadmin_head />
            <inc_zadmin_left />

            <div id="main" class="pu_ContentsWrap sterr">
                <div class="pu_ContentsDiv">

                    <inc_zadmin_title />

                    <!-- 검색조건 (s) -->
                    <section class="pu_searchSection">
                        <form id="searchForm" class="pu_searchBox" onsubmit="return false">

                            <dl>
                                <dt class="pu_wd110"><label for="">용지 설정</label></dt>
                                <dd>
                                    <label>
                                        <input type="radio" name="paperType" value="A4_V" v-model="hash.PAPERTYPE" v-on:click="chagePaperSize('A4_V')" /> A4 세로
                                    </label>
                                    <label>
                                        <input type="radio" name="paperType" value="A4_H" v-model="hash.PAPERTYPE" v-on:click="chagePaperSize('A4_H')" /> A4 가로
                                    </label>
                                    <label>
                                        <input type="radio" name="paperType" value="B4_V" v-model="hash.PAPERTYPE" v-on:click="chagePaperSize('B4_V')" /> B4 세로
                                    </label>
                                </dd>
                                <dt class="pu_wd150"><label for="" style="margin-left: 25px;">레이아웃 설정</label></dt>
                                <dd>
                                    <label>
                                        <input type="radio" name="colType" value="2" v-model="hash.COLTYPE" v-on:click="chagePaperCol(2)" /> 양쪽
                                    </label>
                                    <label>
                                        <input type="radio" name="colType" value="1" v-model="hash.COLTYPE" v-on:click="chagePaperCol(1)" /> 왼쪽
                                    </label>
                                </dd>
                            </dl>

                            <dl>
                                <dt class="pu_wd110"><label for="">머리글 문구</label></dt>
                                <dd>
                                    <input type="text" name="head_left_1" placeholder="[[LEFT_1]]" style="">
                                    <input type="text" name="head_title_1" placeholder="[[TITLE_1]]" style="">
                                    <input type="text" name="head_right_1" placeholder="[[RIGHT_1]]" style="">
                                    <br/>
                                    <input type="text" name="head_left_2" placeholder="[[LEFT_2]]" style="">
                                    <input type="text" name="head_title_2" placeholder="[[TITLE_2]]" style="">
                                    <input type="text" name="head_right_2" placeholder="[[RIGHT_2]]" style="">
                                </dd>
                            </dl>

                            <dl>
                                <dt class="pu_wd110"><label for="">바닥글 문구</label></dt>
                                <dd>
                                    <input type="text" name="foot_left" placeholder="[[LEFT]]" style="">                                    
                                    <input type="text" name="foot_right" placeholder="[[RIGHT]]" style="">
                                </dd>
                            </dl>

                            <dl>
                                <dt class="pu_wd110"><label for="">머리글 양식</label></dt>
                                <dd>
                                    <div class="pu_dateSelect">
                                        <ul class="pu_date_day">
                                            <li v-for="(row, idx) in list_head">
                                                <a v-bind:class="[ idx == head_idx ? 'pu_active' : '' ]"
                                                   href="javascript:;" v-on:click="setHead(idx)"
                                                   style="border-radius:25px;">
                                                    {{ row.TITLE }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </dd>
                            </dl>

                            <dl>
                                <dt class="pu_wd110"><label for="">바닥글 양식</label></dt>
                                <dd>
                                    <div class="pu_dateSelect">
                                        <ul class="pu_date_day">
                                            <li v-for="(row, idx) in list_foot">
                                                <a v-bind:class="[ idx == foot_idx ? 'pu_active' : '' ]"
                                                   href="javascript:;" v-on:click="setFoot(idx)"
                                                   style="border-radius:25px;">
                                                    {{ row.TITLE }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </dd>
                            </dl>

                            <dl>
                                <dt class="pu_wd110"><label for="">문제지</label></dt>
                                <dd>
                                    <div class="pu_dateSelect">
                                        <ul class="pu_date_day">
                                            <li v-for="(row, idx) in list_print_item">
                                                <a v-bind:class="[ row.NO == print_item_no ? 'pu_active' : '' ]"
                                                   href="javascript:;" v-on:click="getExamItemList(row.NO)"
                                                   style="border-radius:25px;">
                                                    {{ row.PRINT_TITLE }} <br />~ {{ row.PRINT_ED_DATE }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </dd>
                            </dl>

                        </form>
                        <div class="">
                            <a class="pu_btn_blue" href="javascript:;" v-on:click="printExamPaper()"><i class="xi-bars"></i> 출력</a>
                        </div>
                    </section>
                    <!-- 검색조건(e) -->
                    <!-- 컨텐츠영역 (s) -->
                    <section class="pu_contentsSection pu_pd15"
                             style="background:#dddddd;">

                        <!--문제 임시로 붙여넣는공간-->
                        <ul id="dev_exam_paper_wrapper_temp"></ul>
                        <!--//문제 임시로 붙여넣는공간-->

                        <!-- 시험지 템플릿 -->
                        <div class="dev_exam_paper pu_exam_paper
                                    pu_exam_paper_title_show pu_exam_paper_A4_V">

                            <!--시험문제 머리글-->
                            <div class="dev_exam_paper_title pu_exam_paper_title">
                                저장된 머리글이 없습니다.
                            </div>
                            <!--//시험문제 머리글-->

                            <!--시험문제 바디-->
                            <div class="dev_exam_paper_body pu_exam_paper_body"></div>
                            <!--//시험문제 바디-->

                            <!--시험문제 바닥글-->
                            <div class="dev_exam_paper_foot pu_exam_paper_foot">
                                저장된 바닥글이 없습니다.
                            </div>
                            <!--//시험문제 바닥글-->
                        </div>
                        <!-- //시험지 템플릿  -->

                        <!--시험지 붙여넣는공간-->
                        <div id="dev_exam_paper_wrapper"></div>
                        <!--//시험지 붙여넣는공간-->

                    </section>
                    <!-- 컨텐츠영역 (e) -->
                </div>
                <div class="pu_pb20"></div>
            </div>
            <!-- 컨텐츠 layout  (e) -->
        </div>
    </div>
</template>

<script>
    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";

    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase"
            }),

        }

        , data() {

            return {
                gubun_page: "VIEW"

                , rownum: 0         // 번호
                , paging: ""        // 페이징

                , paperColCnt: 2
                , paperClass: "pu_exam_paper_A4_V"
                , paperWidth: 1050  // 시험용지 가로
                , paperHeight: 1430 // 시험용지 세로
                , paperHead: 85      // 시험용지 머리글
                , paperFoot: 35      // 시험용지 바닥글
                , paperEtc: 20       // 기타

                , JQ_ExamPaper: {}  // 시험용지
                , JQ_ArrElmCol: []  // 문제 컬럼 배열
                , JQ_ArrElmItem: [] // 문제 아이템 배열

                , hash: {}

                , list_print_item: [] // 프린트 리스트
                , list_exam_item: []  // 시험문제 리스트
                , list_head: []       // 머리글 리스트
                , list_foot: []       // 바닥글 리스트

                , print_item_no: 0 // 프린트 번호
                , head_idx: 0      // 머리글 idx
                , foot_idx: 0      // 바닥글 idx
            }
        }

        , methods: {

            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , init() {

                let _this = this;

                // 시험용지 포멧
                _this.JQ_ExamPaper = $(".dev_exam_paper").detach();

                // 하단여백 조정 버튼 이벤트
                {
                    $(document).off("click", ".dev_btn_m");
                    $(document).on("click", ".dev_btn_m", function () {

                        // 여백 줄이기
                        let $li = $(this).closest(".dev_exam_paper_item");
                        $li.height(Math.max(150, $li.height() - 30));

                        // 높이에 맞춰 재설정
                        _this.setArrangeColItem();
                    });

                    $(document).off("click", ".dev_btn_p");
                    $(document).on("click", ".dev_btn_p", function () {

                        // 여백 늘리기
                        let $li = $(this).closest(".dev_exam_paper_item");
                        $li.height(Math.min((_this.paperHeight - _this.paperHead - _this.paperFoot - _this.paperEtc), $li.height() + 30));

                        // 높이에 맞춰 재설정
                        _this.setArrangeColItem();
                    });

                    $(document).on(
                        "keyup",
                        "[name='head_left_1'], [name='head_title_1'], [name='head_right_1'], " +
                        "[name='head_left_2'], [name='head_title_2'], [name='head_right_2'], " +
                        "[name='foot_left'], [name='foot_right']",
                        function () {

                            _this.setHead(_this.head_idx);
                            _this.setFoot(_this.foot_idx);
                        });
                }

                // 머리글 조회
                _this.getHeadList();

                // 바닥글 조회
                _this.getFootList();

                // 프린트 아이템 조회
                _this.getExamPrintItemList(1);
            }

            // 프린트 아이템 조회
            , getExamPrintItemList: function (curPage) {

                // API 조회
                this.$SendPost("/vue_api/zadmin/exam_print/list_print", {}, this.getExamPrintItemListReturn);
            }
            , getExamPrintItemListReturn: function (data, err) {

                if (data) {

                    // 데이터 처리
                    if (data.RESULT_YN === "Y") {

                        this.hash = data.HASH;
                        this.list_print_item = data.LIST_1;

                        if (!this.list_print_item || this.list_print_item.length < 1) {

                            alert("저장된 시험지가 없습니다.");

                            // dimm 숨기기
                            this.$HideDimmLogo();
                        }
                        else {

                            // qs
                            var qs = this.$GetQueryMap();

                            // 첫 문제지 번호 세팅
                            let no = qs.no || 0;
                            if (no < 1) {
                                no = this.list_print_item[0].NO;
                            }

                            // 문제 아이템 리스트 조회
                            this.getExamItemList(no);
                        }
                    }
                }
            }

            // 문제 아이템 리스트 조회
            , getExamItemList: function (no) {

                // dimm 보이기
                this.$ShowDimmLogo();

                // 조회할 시험지 번호
                this.print_item_no = no;


                let data = {}
                data["no"] = no;

                // API 조회
                this.$SendPost("/vue_api/zadmin/exam_print/list_exam", data, this.getExamItemListReturn);
            }
            , getExamItemListReturn: function (data, err) {

                if (data) {

                    // 데이터 처리
                    if (data.RESULT_YN === "Y") {

                        this.list_exam_item = data.LIST_1;

                        // dimm 숨기기
                        this.$HideDimmLogo();
                    }

                    // 커럼 및 아이템 초기 설정
                    this.setDefaultColItem();
                }
            }


            // 컬럼 및 아이템 초기 설정
            , setDefaultColItem: function () {

                this.JQ_ArrElmCol = [];
                this.JQ_ArrElmItem = [];

                let arrItem = this.list_exam_item;
                if (arrItem) {

                    // 임시영역에 문제 넣음
                    for (let idx_item = 0; idx_item < arrItem.length; idx_item++) {

                        // 번호 수정
                        let item = arrItem[idx_item];
                        item = item.CONT_Q.replace("[[번호]]", (idx_item + 1) + ". ");

                        // li 만들기
                        let JQ_item =
                            $("<li class='dev_exam_paper_item pu_exam_paper_item'>"
                                + item
                                + "<a href='javascript:;' class='dev_btn_m pu_btn_m pu_ss_btn_blue'>하단여백 (-)</a>"
                                + "<a href='javascript:;' class='dev_btn_p pu_btn_p pu_ss_btn_red' >하단여백 (+)</a>"
                                + "</li>");

                        // 아이템 추가
                        this.JQ_ArrElmItem.push(JQ_item);
                        $("#dev_exam_paper_wrapper_temp").append(JQ_item);

                        JQ_item.height(JQ_item.height() + 60);
                    }

                    // 문제 컬럼 대량생성
                    let strUl = "<ul class='dev_exam_paper_col pu_exam_paper_col'></ul>";
                    for (let idx_col = 0; idx_col < 100; idx_col++) {

                        this.JQ_ArrElmCol.push($(strUl));
                    }

                    // 문제 첫번째 컬럼에 문제 다 넣기
                    for (let idx_elmItem = 0; idx_elmItem < this.JQ_ArrElmItem.length; idx_elmItem++) {

                        this.JQ_ArrElmCol[0].append(this.JQ_ArrElmItem[idx_elmItem]);
                    }
                }

                // 높이에 맞춰 재설정
                this.setArrangeColItem();
            }

            // 높이에 맞춰 재설정
            , setArrangeColItem: function () {

                // 임시 컬럼
                let JQ_ArrElmColTemp = $("<ul></ul>");
                for (let idx_col = 0; idx_col < this.JQ_ArrElmCol.length; idx_col++) {

                    let JQ_Elm = this.JQ_ArrElmCol[idx_col].find(".dev_exam_paper_item");
                    for (let idx_elm = 0; idx_elm < JQ_Elm.length; idx_elm++) {

                        JQ_ArrElmColTemp.append($(JQ_Elm[idx_elm]));
                    }
                }


                let hSumElm = 0;                                                  // 누적 아이템 높이
                let hColLim = this.paperHeight - this.paperHead - this.paperFoot - this.paperEtc; // 기준높이 = (용지 높이 - 헤더 높이)
                let JQ_ArrElm = JQ_ArrElmColTemp.find(".dev_exam_paper_item");

                let idx_col = 0;
                for (let idx_elm = 0; idx_elm < JQ_ArrElm.length; idx_elm++) {

                    let JQ_Elm = $(JQ_ArrElm[idx_elm]);
                    let hElm = JQ_Elm.height();

                    // 높이가 넘을것 같으면 다음컬럼
                    if (hSumElm + hElm > hColLim) {

                        idx_col++;
                        hSumElm = 0;
                    }

                    this.JQ_ArrElmCol[idx_col].append(JQ_Elm);
                    hSumElm += hElm;
                }

                // dimm 숨기기
                this.$HideDimmLogo();

                // 시험지 만들기
                this.setExamPaper();
            }

            // 시험지 만들기
            , setExamPaper: function () {

                // 시험지 초기화
                $("#dev_exam_paper_wrapper").empty();

                let cntCur = 0;
                let cntPaper = Math.ceil(this.JQ_ArrElmCol.length / this.paperColCnt);
                for (let idx_paper = 0; idx_paper < cntPaper; idx_paper++) {

                    let JQ_ExamPaper =
                        this.JQ_ExamPaper.clone()
                            .removeClass("pu_exam_paper_A4_V")
                            .removeClass("pu_exam_paper_A4_H")
                            .removeClass("pu_exam_paper_B4_V")
                            .addClass(this.paperClass);

                    let cntItem = 0;
                    for (let idx_col = 0; idx_col < this.paperColCnt; idx_col++) {

                        if (cntCur < this.JQ_ArrElmCol.length) {

                            // 컬럼수
                            let JQ_ElmCol = this.JQ_ArrElmCol[cntCur];
                            JQ_ExamPaper.find(".dev_exam_paper_body").append(JQ_ElmCol);
                            cntCur++;

                            // 문제수
                            cntItem += JQ_ElmCol.find(".dev_exam_paper_item").length;
                        }
                    }

                    // 시험지 추가
                    if (cntItem > 0) {
                        $("#dev_exam_paper_wrapper").append(JQ_ExamPaper);
                    }
                }

                // 머리글 바닥글
                this.setHead(this.head_idx);
                this.setFoot(this.foot_idx);

                // dimm 숨기기
                this.$HideDimmLogo();
            }

            // 시험지 프린트
            , printExamPaper: function () {

                $('.dev_exam_paper').printThis({
                    debug: false,               // show the iframe for debugging
                    importCSS: true,            // import page CSS
                    importStyle: false,         // import style tags
                    printContainer: true,       // grab outer container as well as the contents of the selector
                    //loadCSS: "path/to/my.css",  // path to additional css file - us an array [] for multiple
                    pageTitle: "",              // add title to print page
                    removeInline: false,        // remove all inline styles from print elements
                    printDelay: 500,            // variable print delay
                    header: null,               // prefix to html
                    footer: null,               // postfix to html
                    base: false,                // preserve the BASE tag, or accept a string for the URL
                    formValues: true,           // preserve input/form values
                    canvas: true,               // copy canvas elements (experimental)
                    //doctypeString: '...',     // enter a different doctype for older markup
                    removeScripts: false,       // remove script tags from print content
                    copyTagClasses: false       // copy classes from the html & body tag
                });

            }

            // 용지 변환
            , chagePaperSize: function (size) {

                // 용지 클래스 설정
                this.paperClass = "pu_exam_paper_" + size;

                // 용지 크기 설정
                if (size == "A4_V") {

                    this.paperWidth = 1050;
                    this.paperHeight = 1430;
                }

                if (size == "A4_H") {

                    this.paperWidth = 1430;
                    this.paperHeight = 930;
                }

                if (size == "B4_V") {

                    this.paperWidth = 1260;
                    this.paperHeight = 1720;
                }

                // 높이에 맞춰 재설정
                this.setArrangeColItem();
            }

            // 컬럼 갯수 설정
            , chagePaperCol: function (colCnt) {

                // 갯수 변환
                this.paperColCnt = colCnt;

                // 시험지 만들기
                this.setExamPaper();
            }

            // 머리글 조회
            , getHeadList: function () {

                // API 조회
                this.$SendPost("/vue_api/zadmin/my_head/print_list", {}, this.getHeadListReturn);
            }
            , getHeadListReturn: function (data, err) {

                if (data) {

                    // 데이터 처리
                    if (data.RESULT_YN === "Y") {

                        this.list_head = data.LIST_1;

                        if (this.list_head || this.list_head.length > 0) {

                            // 머리글 첫번째 설정
                            this.setHead(0)
                        }
                    }
                }
            }
            , setHead: function (idx) {

                this.head_idx = idx;

                let cont = this.list_head[idx]["CONTENTS"];

                let left_1 = $("[name='head_left_1']").val().trim();
                let title_1 = $("[name='head_title_1']").val().trim();
                let right_1 = $("[name='head_right_1']").val().trim();
                let left_2 = $("[name='head_left_2']").val().trim();
                let title_2 = $("[name='head_title_2']").val().trim();
                let right_2 = $("[name='head_right_2']").val().trim();

                if (left_1) { cont = cont.replace("[[LEFT_1]]", left_1); }
                if (title_1) { cont = cont.replace("[[TITLE_1]]", title_1); }
                if (right_1) { cont = cont.replace("[[RIGHT_1]]", right_1); }
                if (left_2) { cont = cont.replace("[[LEFT_2]]", left_2); }
                if (title_2) { cont = cont.replace("[[TITLE_2]]", title_2); }
                if (right_2) { cont = cont.replace("[[RIGHT_2]]", right_2); }

                let JQ_Head = $(cont);
                $(".dev_exam_paper_title").empty().append(JQ_Head);
            }

            // 바닥글 조회
            , getFootList: function () {

                // API 조회
                this.$SendPost("/vue_api/zadmin/my_foot/print_list", {}, this.getFootListReturn);
            }
            , getFootListReturn: function (data, err) {

                if (data) {

                    // 데이터 처리
                    if (data.RESULT_YN === "Y") {

                        this.list_foot = data.LIST_1;

                        if (this.list_foot || this.list_foot.length > 0) {

                            // 바닥글 첫번째 설정
                            this.setFoot(0)
                        }
                    }
                }
            }
            , setFoot: function (idx) {

                this.foot_idx = idx;

                let cont = this.list_foot[idx]["CONTENTS"];

                let left = $("[name='foot_left']").val().trim();
                let right = $("[name='foot_right']").val().trim();

                if (left) { cont = cont.replace("[[LEFT]]", left); }
                if (right) { cont = cont.replace("[[RIGHT]]", right); }

                for (let idx = 0; idx < $(".dev_exam_paper_foot").length; idx++) {

                    let JQ_Paper = $($(".dev_exam_paper_foot")[idx]);
                    let _cont = cont.replace("[[NUM]]", "[ " + (idx + 1) + " ]");
                    let JQ_Foot = $(_cont);
                    JQ_Paper.empty().append(JQ_Foot);
                }
            }
        }

        , beforeCreate() {
        }

        , created() {
        }

        , beforeMount() {
        }

        , mounted() {
            this.$AfterMounted(this);
        }

        , beforeUpdate() {
        }

        , updated() {
            this.$AfterUpdated(this);
        }

        , beforeDestroy() {
        }

        , destroyed() {
        }

    }

</script>